// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1TeamSchema } from './v1/teamSchema';

export const get11AccountIdTeamsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the teams you want to retrieve"),
});

export const get11AccountIdTeamsQueryParamsSchema = z.object({
  limit: z.optional(z.number().int().describe("Retrieve number of teams")),
  order: z.optional(z.coerce.string().describe("\"asc (default)\" and \"desc\"")),
  offset: z.optional(z.number().int().describe("Retrieve teams from offset")),
  filter: z.optional(z.coerce.string().describe("Filter teams by \"mine\" or show all")),
}).optional();

export const get11AccountIdTeamsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Team details
 */
export const get11AccountIdTeams200Schema = z.array(z.lazy(() => v1TeamSchema));

export const get11AccountIdTeamsQueryResponseSchema = z.lazy(() => get11AccountIdTeams200Schema);
